"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _TableWrapper = _interopRequireDefault(require("./TableWrapper"));
var _Column = _interopRequireDefault(require("./Components/Column"));
var _ColumnGroup = _interopRequireDefault(require("./Components/ColumnGroup"));
var _PlaceholderView = _interopRequireDefault(require("./Components/PlaceholderView"));
var _EmptyView = _interopRequireDefault(require("./Components/EmptyView"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // Table
// components
var Table = /*#__PURE__*/function (_React$PureComponent) {
  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return _callSuper(this, Table, arguments);
  }
  (0, _inherits2.default)(Table, _React$PureComponent);
  return (0, _createClass2.default)(Table, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
        component: "Table",
        defaultLocale: _default2.default.Table
      }, function (localeCode, locale) {
        return /*#__PURE__*/_react.default.createElement(_TableWrapper.default, (0, _extends2.default)({
          localeCode: localeCode,
          locale: locale
        }, _this.props));
      });
    }
  }]);
}(_react.default.PureComponent);
Table.Column = _Column.default;
Table.ColumnGroup = _ColumnGroup.default;
Table.PlaceholderView = _PlaceholderView.default;
Table.EmptyView = _EmptyView.default;
var _default = exports.default = Table;